export default __webpack_public_path__ + "static/media/PAYW-Pro-Regular.a73ecfb6.otf";